export const visit = (vm, at) => {
at({ "en-gb": { "conversations-visitor-ui": { "pageTitleNotifications": { "newMessage": "New message" } }, "conversationsVisitorUIPageTitleNotifications": { "newMessage": "New message" } } });
};